/* eslint-disable max-len */
import { defineStore } from 'pinia';
import TermService from 'src/lib/api/termService';

export const useTermStore = defineStore('term', {
  state: () => ({
    all: null,
  }),

  getters: {
    getTermById: (state) => (id) => state.all.find((term) => term.id === id),
    getTermsByName: (state) => (name) => state.all.filter((term) => term.name.toLowerCase().includes(name.toLowerCase())),
    getTermsByCategory: (state) => (category) => state.all.filter((term) => term.category === category),
  },

  actions: {
    async searchTerms() {
      const response = await TermService.searchTerms();
      if (response.status === 200) {
        this.all = response.data.data.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      }
    },
  },
});
